/** Téléphones : normalisation internationale et liens WhatsApp (Sénégal par défaut) */
export class PhoneUtil {
  /** Chiffres au format international sans « + » (ex. 221771234567), ou '' si inexploitable */
  static e164(tel: string | null | undefined, indicatif = '221'): string {
    let d = (tel || '').replace(/\D/g, '');
    if (!d) return '';
    if (d.startsWith('00')) d = d.slice(2);
    if (d.length === 9 && indicatif === '221') d = indicatif + d;   // 77 / 78 / 76 / 70 / 75 / 33 xxx xx xx
    else if (d.length <= 9 && indicatif) d = indicatif + d.replace(/^0/, '');
    return d.length >= 10 ? d : '';
  }

  /** Affichage lisible : +221 77 123 45 67 */
  static affichage(tel: string | null | undefined): string {
    const d = PhoneUtil.e164(tel);
    if (!d) return tel || '';
    if (d.startsWith('221') && d.length === 12) {
      return `+221 ${d.slice(3, 5)} ${d.slice(5, 8)} ${d.slice(8, 10)} ${d.slice(10)}`;
    }
    return '+' + d;
  }

  /** Lien wa.me : avec numéro si connu, sinon WhatsApp demande le destinataire */
  static lienWhatsApp(tel: string | null | undefined, texte: string): string {
    const d = PhoneUtil.e164(tel);
    return `https://wa.me/${d}?text=${encodeURIComponent(texte || '')}`;
  }
}

/** Remplace les variables {cle} d'un modèle de message ; une variable vide disparaît proprement */
export function remplirModele(modele: string, valeurs: { [cle: string]: string | number | null | undefined }): string {
  return (modele || '')
    .replace(/\{([a-z_]+)\}/g, (_, cle) => {
      const v = valeurs[cle];
      return v == null ? '' : String(v);
    })
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
